function isValidHtml(description, allowedTags) {
    const regex = /<\/?([a-zA-Z0-9]+)[^>]*>/g;
    let match;
    while ((match = regex.exec(description)) !== null) {
        let tag = match[1].toLowerCase();
        if (!allowedTags.includes(tag)) {
            return false;
        }
    }
    return true;
}

function validateAndReturnHtml(description, allowedTags) {
    return isValidHtml(description, allowedTags) ? description : "";
}

function validateAndReturnComments(comments) {
    const COMMENTS_ALLOWED_TAGS = ["br", "a", "b", "strong"];
    return validateAndReturnHtml(comments, COMMENTS_ALLOWED_TAGS);
}

function validateAndReturnDescription(description) {
    const DESCRIPTION_ALLOWED_TAGS = [
        "p", "b", "strong", "li", "ul", "br", "i", "em", "a"
    ];
    return validateAndReturnHtml(description, DESCRIPTION_ALLOWED_TAGS);
}

export {
validateAndReturnComments, validateAndReturnDescription
};

